
export default {
  props: ["item", "height", "index"],
  data() {
    return {
      promos: [],
      pickGift: false,
      quantityOn: false,
    };
  },
  methods: {
    reset() {},
    linkItemQuantity(item) {
      return (
        (((this.$hyperCart.getCart() || {}).items || []).find(
          (i) => i.barcode == item.barcode
        )||{}).quantity || 1
      );
    },
    async add() {
      this.item.quantity = this.linkItemQuantity(this.item);
      this.item.index = this.index || 0;
      let error = await this.$hyperCart.addToCart(
        { ...this.item, quantity: 1 },
        false,
        this.item.quantity,
        true,
        false,
        true
      );
      if (error === false) {
        this.$emit("error", error);
        return;
      } else {
        Object.keys(error).forEach((k) => {
          this.item[k] = error[k];
        });
      }
      if (!this.promos.length) {
        this.promos = await this.$hyperItem.promos(this.item, "smartbuy");
      }
      
      this.quantityOn = true;
      setTimeout(() => {
        this.quantityOn = false;
      }, 9000);
    },
    async increase() {
      this.item.index = this.index || 0;
      await this.$hyperCart.increaseCartQuantity(
        this.item,
        this.$hyperCart.getCart(),
        true
      );
    },
    async decrease() {
      this.item.index = this.index || 0;
      if ((this.item || {}).quantity == 1) {
        await this.$hyperCart.removeItem(this.item, this.$hyperCart.getCart());
        this.quantityOn = false;
        return;
      }
      await this.$hyperCart.decreaseCartQuantity(
        this.item,
        this.$hyperCart.getCart(),
        true
      );
    },
  },
  
};
